module.exports = __webpack_public_path__ + "img/icons-timer.0e5c4351.svg";